import React from "react";
import { BsLinkedin } from "react-icons/bs";
import { FaGithub } from "react-icons/fa";
import { FiDribbble } from "react-icons/fi";
import "animate.css/animate.min.css";
import { AnimationOnScroll } from "react-animation-on-scroll";
function HeaderSocails({ darkMode }) {
  return (
    <div className={darkMode ? "header__socials" : "header__socials light"}>
      <AnimationOnScroll animateOnce="true" animateIn="animate__fadeInLeftBig">
        <a href="https://linkedin.com" target="__blank">
          <BsLinkedin />
        </a>
      </AnimationOnScroll>

      <AnimationOnScroll animateOnce="true" animateIn="animate__fadeInLeftBig">
        <a href="https://github.com" target="__blank">
          <FaGithub />
        </a>
      </AnimationOnScroll>

      <AnimationOnScroll animateOnce="true" animateIn="animate__fadeInLeftBig">
        <a href="https://dribbble.com" target="__blank">
          <FiDribbble />
        </a>
      </AnimationOnScroll>
    </div>
  );
}

export default HeaderSocails;
